module.exports = __webpack_public_path__ + "catalog/items/kitchen/Standard-Gas-Hob/Standard-Gas-Hob.svg";